class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  // ---- NEW: extract keys from /cart/add response (single or multi add)
  extractAddedKeys(parsedState) {
    if (parsedState?.key) return [parsedState.key];
    if (Array.isArray(parsedState?.items)) {
      return parsedState.items.map(i => i?.key).filter(Boolean);
    }
    return [];
  }

  renderContents(parsedState) {
    const addedKeys = this.extractAddedKeys(parsedState);
    this.addedKeys = addedKeys; // store for this render

    // Keep prior single key for Dawn compatibility, but we won't rely on it
    this.cartItemKey = addedKeys[0] || this.cartItemKey || null;

    const sections = this.getSectionsToRender();
    const incoming = parsedState?.sections || {};

    sections.forEach((section) => {
      const mount = document.getElementById(section.id);
      const html = incoming[section.id];
      if (!mount || !html) return;

      if (section.id === 'cart-notification-product') {
        mount.innerHTML = this.getFilteredProductHTML(html, addedKeys);
      } else {
        mount.innerHTML = this.getSectionInnerHTML(html, section.selector);
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  // ---- NEW: keep only nodes for the keys we just added
  getFilteredProductHTML(html, keys = []) {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // If we have keys, extract exact product blocks by id:
    // <div id="cart-notification-product-<key>">...</div>
    if (keys.length) {
      const wrapper = doc.createElement('div');
      wrapper.className = 'shopify-section';

      keys.forEach((key) => {
        const node = doc.querySelector(`[id="cart-notification-product-${key}"]`);
        if (node) wrapper.appendChild(node.cloneNode(true));
      });

      // If nothing matched (edge case), fall back to generic section root
      if (wrapper.children.length) return wrapper.innerHTML;
    }

    // Fallbacks: use targeted selector or .shopify-section or raw html
    return this.getSectionInnerHTML(html, this.cartItemKey
      ? `[id="cart-notification-product-${this.cartItemKey}"]`
      : '.shopify-section'
    );
  }

  getSectionsToRender() {
    // Selector here is only used as a fallback; primary filter uses keys above
    const productSelector = this.cartItemKey
      ? `[id="cart-notification-product-${this.cartItemKey}"]`
      : '.shopify-section';

    return [
      { id: 'cart-notification-product', selector: productSelector },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = (selector && doc.querySelector(selector)) || doc.querySelector('.shopify-section');
    return node ? node.innerHTML : html;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
